import * as types from "./types";

const initialState = {
  themes: [],
  isLoading: false
};

const reducers = (state: any = initialState, action: { type: string, [key: string]: any }) => {
  switch (action.type) {
    case types.SET_THEMES:
      return {
        ...state, themes: action.themes
      };
    case types.IS_LOADING:
      return {
        ...state, isLoading: action.isLoading
      };
    default:
      return state;
  }
};

export { initialState };
export default reducers;